import { NgModule } from '@angular/core';
import { DateFormatPipe } from './date-format-pipe';
import { DateFormatType } from './date-format-type';

@NgModule({
    declarations: [DateFormatPipe],
    imports: [],
    exports: [DateFormatPipe],
})
export class DateFormatModule {}
